import { render, staticRenderFns } from "./TranslateControl.vue?vue&type=template&id=09d44a0f"
import script from "./TranslateControl.vue?vue&type=script&lang=js"
export * from "./TranslateControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports